<template>
    <div>
        <div
            class="collapsible is-pointer"
            :class="{ 'is-active': isOpen }"
            @click="toggleCollapse"
        >
            <p class="unselectable-text">{{ name }}</p>
        </div>
        <div
            class="collapse-content has-background-white"
            :class="{ 'is-active': isOpen }"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "collapse",
    props: {
        name: {
            type: String,
            required: true,
        },
        opened: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isOpen: true,
        };
    },
    mounted() {
        this.isOpen = this.opened;
    },
    methods: {
        toggleCollapse() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>

<style lang="scss" scoped>
.collapsible {
    background-color: #777;
    color: white;
    cursor: pointer;
    margin-top: 0.25rem;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    width: 100%;
    border: none;
    text-align: left;
    outline: none;
    font-size: 15px;
}

.collapse-content {
    padding: 0rem;
    max-height: 0;
    max-width: fit-content;
    overflow: auto;
    transition: max-height 0.1s ease-out;
    margin-bottom: 0.5rem;
    border: none;

    &.is-active {
        padding: 0.5rem;
        max-height: 25vh;
        overflow-y: auto;
        border: 0.5px solid #000;
    }
}
</style>